module.exports = __webpack_public_path__ + "media/images/author/author-6-0f5526d6f6dd00aff0c2539ab82cce9b.jpg";